import React from 'react';
import { ChevronDown, Download, FileText, Paperclip } from 'lucide-react';
import { ProductAttachment } from '../../types';
import { formatBytes } from '../../utils/allegati';

/** Documenti PDF dell'articolo (schede tecniche, SDS, manuali), caricati
 *  dall'admin. Il nome apre il PDF in una nuova scheda; l'icona lo scarica.
 *  Chiuso di default, col numero dei documenti: è un `<details>` come i
 *  gruppi del footer, quindi accessibile senza stato React. */
export function ProductAttachments({ attachments }: { attachments: ProductAttachment[] }) {
  if (attachments.length === 0) return null;
  return (
    <details className="group mb-6 rounded-lg border [&_summary::-webkit-details-marker]:hidden" data-testid="product-attachments">
      <summary className="tap flex min-h-[44px] cursor-pointer list-none items-center gap-2 px-3 py-2 rounded-lg hover:bg-[hsl(var(--dtk-canvas))]">
        <Paperclip className="w-4 h-4 text-[hsl(214,58%,41%)]" aria-hidden="true" />
        <h2 className="text-sm font-semibold">Documenti</h2>
        <span className="ml-auto text-[11px] font-semibold tabular-nums text-[hsl(214,58%,41%)] bg-blue-50 border border-blue-200 rounded-full px-2 py-0.5" data-testid="product-attachments-count">
          {attachments.length}
        </span>
        <ChevronDown
          className="w-4 h-4 text-muted-foreground transition-transform group-open:rotate-180 motion-reduce:transition-none"
          aria-hidden="true"
        />
      </summary>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 px-3 pb-3 pt-1">
        {attachments.map(att => (
          <li key={att.id} className="flex items-center gap-2 rounded-lg border bg-[hsl(var(--dtk-canvas))] hover:border-[hsl(214,58%,41%)] transition-colors">
            <a
              href={att.url}
              target="_blank"
              rel="noopener noreferrer"
              className="tap flex-1 min-w-0 flex items-center gap-2.5 px-3 py-2.5"
              data-testid="product-attachment-link"
            >
              <FileText className="w-4 h-4 text-red-600 flex-shrink-0" />
              <span className="min-w-0">
                <span className="block text-sm font-medium truncate">{att.name}</span>
                <span className="block text-[11px] text-muted-foreground">PDF · {formatBytes(att.size)}</span>
              </span>
            </a>
            <a
              href={att.downloadUrl}
              title={`Scarica ${att.name}`}
              aria-label={`Scarica ${att.name}`}
              className="tap w-11 h-11 flex items-center justify-center text-[hsl(214,58%,41%)] flex-shrink-0"
            >
              <Download className="w-4 h-4" />
            </a>
          </li>
        ))}
      </ul>
    </details>
  );
}
